import {OperatingAreaSelectorProps, operatingAreasSelector, useGetAllOperatingAreasQuery} from "@ots-frontend/ots-data";
import {BaseOperatingAreaSelect, BaseOperatingAreaSelectProps} from "./BaseOperatingAreaSelect";
import {useMemo} from "react";

export type OperatingAreaSelectProps = Omit<BaseOperatingAreaSelectProps, "entities" | "loading"> & {
    selector?: OperatingAreaSelectorProps
}

export const OperatingAreaSelect = (props: OperatingAreaSelectProps) => {
    const {selector, ...rest} = props;

    const selectOperatingAreas = useMemo(() => {
        return operatingAreasSelector();
    }, []);

    const {operatingAreas, isLoading} = useGetAllOperatingAreasQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            operatingAreas: selectOperatingAreas(result, selector),
            isLoading: result.isLoading
        })
    });

    return <BaseOperatingAreaSelect entities={operatingAreas} loading={isLoading} {...rest} />;
};
